import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { ApiService } from './api.service';
import { EntityService } from './entity.service';

@Injectable()
export class ExchangeApiService extends EntityService {
  public subject = new Subject<void>();
  private readonly errorPrefix: string = 'Exchange';
  private getSubject: BehaviorSubject<any>[] = [];

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {
    super();
  }

  get(path: string, params: HttpParams = new HttpParams(), lang: string = '', displayErrors: boolean = true): Observable<any> {
    path = path.replace('/api/', '');

    return this.http.get(
      `${environment.exchangeApi.url}${path}`,
      this.makeHttpOptions(params, lang),
    ).pipe(
      catchError((error) => true === displayErrors ? this.apiService.formatErrors(error, this.errorPrefix) : of(null)),
    );
  }

  public getSave(path: string, args?: any): Observable<any> {
    const params = args?.find(arg => arg instanceof HttpParams) ?? new HttpParams();
    const lang = args?.find(arg => typeof arg === 'string') ?? '';
    const parameters = [this.http, `${environment.exchangeApi.url}${path}`, this.makeHttpOptions, params, lang];
    return this.getSavedApiCall(this.getSubject, this.getApi,parameters);
  }

  put(path: string, body= {}, lang: string = ''): Observable<any> {
    return this.http.put(
      `${environment.exchangeApi.url}${path}`,
      JSON.stringify(body),
      this.makeHttpOptions(null, lang),
    ).pipe(
      catchError((error) => this.apiService.formatErrors(error, this.errorPrefix)),
    );
  }

  post(path: string, body= {}, lang: string = ''): Observable<any> {
    return this.http.post(
      `${environment.exchangeApi.url}${path}`,
      JSON.stringify(body),
      this.makeHttpOptions(null, lang),
    ).pipe(
      catchError((error) => this.apiService.formatErrors(error, this.errorPrefix)),
    );
  }

  delete(path, body= {}): Observable<any> {
    return this.http.request(
      'delete',
      `${environment.exchangeApi.url}${path}`,
      {...this.makeHttpOptions(), body},
    ).pipe(
      catchError((error) => this.apiService.formatErrors(error, this.errorPrefix)),
    );
  }

  upload(path: string, body= {}, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.post(
      `${environment.exchangeApi.url}${path}`,
      body,
      {...this.makeHttpOptions(params), reportProgress: true},
    ).pipe(
      catchError((error) => this.apiService.formatErrors(error, this.errorPrefix)),
    );
  }

  download(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(
      `${environment.exchangeApi.url}${path}`,
      {...this.makeHttpOptions(params), responseType: 'blob'},
    ).pipe(
      catchError((error) => this.apiService.formatErrors(error, this.errorPrefix)),
    );
  }

  private makeHttpOptions(params: HttpParams = null, lang: string = ''): any {

    const header = {headers : {}};
    if (environment.key !== '') {
      header['headers']['x-api-key'] = environment.key;
    }

    if (lang) {
      header['headers']['Accept-Language'] = lang;
    }

    return {
      ...(params && {params}),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      ...header,
    };
  }

  private getApi(
    service: HttpClient,
    path: string,
    makerOption: any,
    params: HttpParams = new HttpParams(),
    lang: string = ''): Observable<any> {
    return service.get(
      path,
      makerOption(params, lang),
    ).pipe(
      catchError((error) => this.apiService.formatErrors(error, this.errorPrefix)),
    );
  }

}
